<template>
  <div id="applyFileUpload">


    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <!-- 
      :selectList="selectList"
      :requestForm="requestForm"
     -->
    <ots-table-group-new
      @search="search"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>

    <!-- 单个处理异常弹窗 -->
    <ots-custom-dialog :dialog.sync="uploadDialog" title="报名材料上传" width="720px">
      <template v-slot:content>
        <div>
          <el-form inline label-width="100px">
            <!-- <div>
              <el-form-item label="姓名">
                <span>{{ currentStudent.realName }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="证件号">
                <span>{{ currentStudent.cardNo }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考试状态">
                <el-select v-model="signParams.checkState" placeholder="请选择">
                  <el-option
                    v-for="item in examSignList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <p class="col_red mt15">
                  设置后学生考试分数将置为0，请慎重操作！
                </p>
              </el-form-item>
            </div> -->
            <div>
              <el-form-item label="批次名称：">
                <el-select v-model="requestForm.planId" placeholder="请选择" :filterable="true">
                  <el-option v-for="item in planList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="报名附件：" width="100%">
                <el-upload
                  class="upload-demo"
                  action=""
                  :on-change="handleSuccess"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  :before-upload="beforeAvatarUpload" 
                  :http-request="uploadImg"
                  list-type="picture">
                  <el-button size="small" type="primary" v-if="!isShow">点击上传</el-button>
                  <span style="margin-left: 16px;" v-if="!isShow">可上传 <span style="color: #fe5859;">JPG，JPEG，PNG，PDF</span> 格式文件</span>
                  <!--  @click="openImg(file, file.url)" -->
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.type == 'pdf'? defaultUrl: file.url" alt=""  @click="openImg(file, file.url)" >
                    <span class="el-upload-list__item-actions">
                      <a class="el-upload-list__item-name"><i class="el-icon-document"></i></a>
                      <span class="el-upload-list__item-preview">
                        {{ file.name }}
                      </span>
                    </span>
                    <label class="el-upload-list__item-status-label">
                      <i class="el-icon-upload-success el-icon-check"></i>
                    </label>
                    <i class="el-icon-close" @click="handleRemove(file, fileList)" v-show="isShow && isCanChange"></i>
                  </div>
                </el-upload>
              </el-form-item>
            </div>

            <div></div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="uploadDialog = false">取消</el-button>
        <el-button round type="primary" @click="executeUpload">确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getPagePlan } from "@/http/modules/examSet/examBatch";
import { getStationFilesAPI, uploadStationFilesAPI, saveStationFilesAPI, deleteStationFilesAPI } from "@/http/modules/custom";

export default {
  data() {
    return {
      defaultUrl: require("@/assets/img/PDFIcon.png"),
      fileList: [],
      mainTopBtnList: [
        {
          title: '材料上传',
          fn: this.uploadStationFiles
        }
      ],
      requestForm: {
        planId: "",
        page: 1,
        size: 10,
      },
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
          isSearch: true,
        },
      ],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "启用状态",
          prop: "planName",
          formatter: (scope) => {
            return scope.row.canEdit == 1 ? "启用": "停用";
          }
        },
        {
          title: "上传时间",
          prop: "createDate",
        },
        {
          title: "审核状态",
          prop: "auditStatusName",
        },
        {
          title: "审核时间",
          prop: "auditDate",
        },
        {
          title: "审核意见",
          prop: "auditRemark",
        },
        {
          title: "报名附件",
          type: "button",
          prop: "",
          formatter: () => "查看",
          click: this.showUploadFile,
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "提交",
              formatter: (scope) => {
                if (scope.row.canEdit == 1) {
                  if (scope.row.auditStatusName == "未提交" || scope.row.auditStatusName == "审核不通过") {
                    return false;
                  } else {
                    return true;
                  }
                } else {
                  return true;
                }
              },
              click: (row) => {
                this.saveStationFiles(row, 1)
              },
            },
            {
              title: "撤回",
              formatter: (scope) => {
                let status = ["审核通过", "审核不通过", "未提交"];
                return status.includes(scope.row.auditStatusName);
              },
              click: (row) => {
                this.saveStationFiles(row, 0)
              },
            },
          ],
        },
      ],
      tableData: [],
      pagination: { total: 0 },
      uploadDialog: false,
      planList: [],
      isShow: false,
      stationFilesId: "",
      isCanChange: false,
    }
  },

  watch: {
    "requestForm.planId": "getTableData"
  },


  created() {
    // han0007
    // Qaz@2024
  },

  mounted() {
    this.initData();
  },

  methods: {
    /*************************************
     * @param { 初始化数据 }
     ************************************/
    async initData() {
      const { data } = await getPagePlan({ publish: 1, state: 1 });
      this.planList = data;
      this.requestForm.planId = data[0].id;
    }, 

    /*************************************
     * @param { 查询 }
     ************************************/
    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },

    /*************************************
     * @param { 表格查询 }
     ************************************/
    async getTableData() {
      let params = { 
        size: this.requestForm.size,
        page: this.requestForm.page
      };
      const { data, code } = await getStationFilesAPI(params);
      if (code) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }
    },

    /*************************************
     * @param { 材料上传 }
     ************************************/
    uploadStationFiles() {
      this.fileList = [];
      this.isShow = false;
      this.$nextTick(() => {
        this.uploadDialog = true;
      })
    },

    /*************************************
     * @param { 材料上传：本地删除 }
     ************************************/
    async handleRemove(file, fileList) {
      let params = {
        stationFilesId: this.stationFilesId,
        stationFilesDetailId: file.stationFilesDetailId
      }
      const { code } = await deleteStationFilesAPI(params);
      if (code) {
        this.$message.success("删除成功！");
      }
      this.fileList = fileList.filter(function(e){
        return e.uid != file.uid;
      });

      this.getTableData();
    },
    
    /*************************************
     * @param { 材料上传：本地上传成功 }
     ************************************/
    handleSuccess(file, fileList) {
      fileList.map( e => {
        e.type = e.name.substring(e.name.lastIndexOf(".") + 1);
      })
      this.fileList = fileList;
    },

    /*************************************
     * @param { 材料上传：格式校验 }
     ************************************/
    beforeAvatarUpload(fileData) {
      let ImgRules = ["jpg", "jpeg", "png", "pdf"]
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < 2048 * 4;
      if (!isJPG && !isLt30kb) {
        this.$message.error(`该批次上传图片只能是 "jpg", "jpeg", "png" 格式，且大小不能超过 2048 kb! `);
      } else if (!isJPG) {
        this.$message.error(`该批次上传图片只能是 "jpg", "jpeg", "png" 格式!`);
      } else if (!isLt30kb) {
        this.$message.error(`该批次上传图片大小不能超过 2048 kb!`);
      }
      return isJPG && isLt30kb;
    },

    /*************************************
     * @param { 材料上传：执行 }
     ************************************/
    async uploadImg(data) {
      const formData = new FormData();
      formData.append("file", data.file);
      formData.append("planId", this.requestForm.planId);
      await uploadStationFilesAPI(formData);
    },

    /*************************************
     * @param { 材料上传：关闭弹窗 }
     ************************************/
    executeUpload() {
      this.getTableData();
      this.uploadDialog = false;
    },

    /*************************************
     * @param { 报名附件：查看 }
     ************************************/
    async showUploadFile(row) {
      let status = ["审核不通过", "审核通过", "未提交"]

      this.isCanChange = row.auditStatusName == "未提交";

      this.stationFilesId = row.stationFilesId;
      let fileData = [];
      row.detailList.map( e => {
        let type = e.fileName.substring(e.fileName.lastIndexOf(".") + 1);
        let item = { url: e.fileUrl, name: e.fileName, stationFilesDetailId: e.stationFilesDetailId, type };
        fileData.push(item);
      })
      this.fileList = fileData;
      this.$nextTick(() => {
        this.isShow = true;
        this.uploadDialog = true;
      })
    },

    /*************************************
     * @param { 报名附件：提交、撤回 }
     ************************************/
    async saveStationFiles(row, auditFlag) {
      let params = {
        stationFilesId: row.stationFilesId,
        auditFlag
      }
      const { code } = await saveStationFilesAPI(params);
      if (code == 1) {
        this.$message.success(`${auditFlag == 1 ? '提交成功！': '撤回成功！'}`);
        this.getTableData();
      }
    },

    openImg(file, url) {
      window.open(url);
    },

    changeSize(num) {
      this.requestForm.size = num;
      this.getTableData();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }
}
</script>

<style scoped lang="less">
.el-form-item {
  display: flex;
  align-items: center;
}
/deep/ .el-upload-list__item {
  min-width: 450px;
}
</style>